import Page from "webPage/Page";
import showBgElements from "util/showBgelements";

Page.register('blog', () => {
    showBgElements();

    $(window).on('resize', showBgElements);
});


